import React, { useContext, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { PlansContext } from '../../../../../../context/plans/plansContext';
import { IMembersData } from '../../../../../../interfaces/businessData';
import { TRANSLATIONS_COLLABORATOR_STATUS_V3 } from '../../../../../../translations/collaborators';
import { formatDocValue } from '../../../../../../utils/docValue/docValue';

interface CollaboratorsDocValueProps {
  collaborator: IMembersData;
}

const CollaboratorsDocValue = ({ collaborator }: CollaboratorsDocValueProps) => {
  const [docValue, setDocValue] = useState<string>();
  const { plans } = useContext(PlansContext);
  const { t } = useTranslation();

  useEffect(() => {
    const planId = collaborator.plans[0];
    const plan = plans.find((plan) => plan.id.toString() === planId);
    if (!plan || !collaborator.nationalIdentifications.idValue || !collaborator.nationalIdentifications.type) {
      setDocValue(undefined);
      return;
    }
    const formatted = formatDocValue(
      plan.countryCode,
      collaborator.nationalIdentifications.type,
      collaborator.nationalIdentifications.idValue
    );
    setDocValue(formatted);
  }, [plans, collaborator]);

  return docValue ? (
    <div className="w-fit" style={{ minWidth: 204 }}>
      {docValue}
    </div>
  ) : (
    <div className="placeholder">{t(TRANSLATIONS_COLLABORATOR_STATUS_V3.pending)}</div>
  );
};

export default CollaboratorsDocValue;
